<template>
  <div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
        v-if="showQueryBar"
    >
      <el-form-item label="外销合同编号：" v-if="hideQuery.indexOf('orderCode') === -1">
        <el-input size="mini" v-model="dataForm.orderCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="外销合同编号：" v-if="hideQuery.indexOf('fuzzyOrderCode') === -1">
        <el-input size="mini" v-model="dataForm.fuzzyOrderCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货批次号：">
        <el-input size="mini" v-model="dataForm.batchCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="进出口发票号：" prop="boxReceiptCode" v-if="hideQuery.indexOf('boxReceiptCode') === -1">
        <el-input size="mini" v-model="dataForm.boxReceiptCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货方：" v-if="queryType==='receiver'">
        <el-input size="mini" v-model="dataForm.senderName" clearable></el-input>
      </el-form-item>
      <el-form-item label="收货方：" v-if="hideQuery.indexOf('receiverName') === -1">
        <el-input size="mini" v-model="dataForm.receiverName" clearable></el-input>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="请输入幅宽"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
        ></el-input>
      </el-form-item>
      <el-form-item prop="status" label="收货状态：" v-if="hideQuery.indexOf('status') === -1">
        <el-select v-model="dataForm.status" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="未收货" value="10"></el-option>
          <el-option label="已收货" value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hasReceipt" label="开票情况：" v-if="hideQuery.indexOf('hasReceipt') === -1">
        <el-select v-model="dataForm.hasReceipt" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="未开票" value="0"></el-option>
          <el-option label="已开票" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hasBack" label="退货情况：" v-if="hideQuery.indexOf('hasBack') === -1">
        <el-select v-model="dataForm.hasBack" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="无退货" value="0"></el-option>
          <el-option label="有退货" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货时间：">
        <el-date-picker
            v-model="sendDateRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期" size="mini"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item v-if="hideButtons.indexOf('receive') === -1 && $hasPermission('erp:store:receive')">
        <el-button @click="showReceiveDialog()" size="mini" type="warning">确认收货
        </el-button>
      </el-form-item>
      <!--      <el-form-item v-if="hideButtons.indexOf('changePrice') === -1 && $hasPermission('erp:store:change:price')">-->
      <!--        <el-button @click="showChangePriceDialog()" size="mini" type="warning">调整单价-->
      <!--        </el-button>-->
      <!--      </el-form-item>-->
      <el-form-item v-if="hideButtons.indexOf('back') === -1 && $hasPermission('erp:store:back')">
        <el-button @click="showBackDialog()" size="mini" type="warning">退货
        </el-button>
      </el-form-item>
      <el-form-item v-if="hideButtons.indexOf('cancel') === -1 && $hasPermission('erp:store:cancel')">
        <el-button @click="batchDel()" size="mini" type="danger">撤回发货单
        </el-button>
      </el-form-item>
      <el-form-item v-if="hideButtons.indexOf('cancel') === -1 && $hasPermission('erp:store:edit')">
        <el-button @click="showStoreLogEditDialog()" size="mini" type="danger">发货单修改
        </el-button>
      </el-form-item>
      <el-form-item v-if="queryType==='seller'" >
        <div class="flex-l">
          <div class="flex-l">
            <div style="width: 20px;height: 20px;background-color:#a400a2;margin: 0 4px 0 10px;"></div>
            <div style="color:#a400a2;">未确认收货</div>
          </div>
          <div class="flex-l">
            <div style="width: 20px;height: 20px;background-color:red;margin: 0 4px 0 10px;"></div>
            <div style="color:red;">超出计划数</div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <slot name="opt-bar"></slot>
    <SweetTable ref="table" :selection="true" api-version="v2" url="/trade/factorystorelog/page" :auto-load="false"
                :query-form="dataForm" :before-table-binding="beforeTableBinding" :height="tableHeight"
                :is-page="hasPage"
                :summaries-column="['count','sendCount','backCount','transferCount']"
                :defaultQueryParams="defaultQueryParams"
                :cell-style="cellStyleHandler">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <span>{{ row.orderCode }}</span>
          <el-tag type="success" style="margin-left: 6px;" size="mini"
                  v-if="row.orderStatus===$const.orderStatus.COMPLETED">已结束
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true"
      ></el-table-column>
      <el-table-column
          prop="boxReceiptCode"
          label="进出口发票号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true" v-if="hideColumns.indexOf('boxReceiptCode') === -1"
          width="110" :show-tooltip-when-overflow="true"
      ></el-table-column>
      <el-table-column
          v-if="queryType==='receiver'"
          prop="senderName"
          label="发货方"
          header-align="center"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="160"
          :formatter="$c.companyNameFormatter"
          v-if="hideColumns.indexOf('receiverName') === -1"
      ></el-table-column>
      <el-table-column label="货物信息" min-width="300" :show-overflow-tooltip="true">
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column
          prop="planCount"
          label="总计划数"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="总收货数"
          header-align="center"
          align="center"
          prop="totalReceiveCount"
          width="100"
          v-if="hideColumns.indexOf('totalReceiveCount')===-1"
      >
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="本批发货数"
          header-align="center"
          align="center"
          width="100"
      >
        <template #default="{row}">
          <span :style="row.type===-1?'color:red;':''">{{row.type*row.sendCount}}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="本批收货数"
          header-align="center"
          align="center"
          prop="count"
          width="100"
          v-if="hideColumns.indexOf('count')===-1"
      >
      </el-table-column>

      <el-table-column
          label="退货数"
          header-align="center"
          align="center"
          prop="backCount"
          width="100"
          v-if="hideColumns.indexOf('backCount') === -1"
      >
        <template #default="{row}">
          <el-link type="danger" v-if="row.backCount>0" @click="showBackDetailDialog(row)">{{ row.backCount }}</el-link>
          <span v-else>{{ row.backCount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="调出数"
          header-align="center"
          align="center"
          prop="transferCount"
          width="100"
          v-if="hideColumns.indexOf('transferCount') === -1"
      >
        <template #default="{row}">
          <el-link type="danger" v-if="row.transferCount>0" @click="showBackDetailDialog(row)">{{
              row.transferCount
            }}
          </el-link>
          <span v-else>{{ row.transferCount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="发货单价"
          header-align="center"
          align="center"
          prop="price"
          width="120"
          v-if="hideColumns.indexOf('price') === -1"
      >
      </el-table-column>
      <el-table-column
          label="发货时间"
          header-align="center"
          align="center"
          prop="operateTime"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="收货时间"
          header-align="center"
          align="center"
          prop="receiveOptTime"
          width="100"
          v-if="hideColumns.indexOf('receiveOptTime') === -1"
      >
      </el-table-column>
      <el-table-column
          label="制单时间"
          header-align="center"
          align="center"
          prop="createDate"
          width="160"
      >
      </el-table-column>
      <el-table-column
          label="发货操作人"
          header-align="center"
          align="center"
          prop="creatorName"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="收货操作人"
          header-align="center"
          align="center"
          prop="receiveOptManName"
          width="100"
          v-if="hideColumns.indexOf('receiveOptManName') === -1"
      >
      </el-table-column>
      <el-table-column
          label="开票情况"
          header-align="center"
          align="center"
          width="120"
          v-if="hideColumns.indexOf('receipt') === -1"
      >
        <template #default="{row}">
          <span v-if="row.status===10">未确认收货,无法开票</span>
          <span v-else-if="row.receiptDetailId">{{ row.receiptCode ? row.receiptCode : '申请中' }}</span>
          <span v-else>未开票</span>
        </template>
      </el-table-column>
      <el-table-column
          label="备注"
          header-align="center"
          align="center"
          prop="fullRemark"
          width="100" :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="凭证照片"
          header-align="center"
          align="center"
          prop="fullRemark"
          width="100" :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <el-button type="text" v-if="row.fullImgs.length>0" @click="$refs.ImagePreviewer.init(row.fullImgs)">
            查看凭证
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <ImagePreviewer ref="ImagePreviewer"></ImagePreviewer>
    <ProductReceiveDialog ref="ProductReceiveDialog" :source-table="sourceTable"
                          @change="getDataList"></ProductReceiveDialog>
    <!--    <ChangePriceDialog ref="ChangePriceDialog" @changed="getDataList"></ChangePriceDialog>-->
    <BackDialog ref="BackDialog" @changed="getDataList"></BackDialog>
    <StoreLogEditDialog ref="StoreLogEditDialog" @changed="getDataList"></StoreLogEditDialog>
    <BackDetailDialog ref="BackDetailDialog"></BackDetailDialog>
  </div>
</template>

<script>
import StoreLogEditDialog from '@/views/modules/erp/store/StoreLogEditDialog.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'
import ProductReceiveDialog from '@/components/ProductReceiveDialog.vue'
import SweetTable from '@/mixins/SweetTable'
import ImagePreviewer from '@/components/ImagePreviewer.vue'
import moment from 'moment'
import BackDialog from '@/views/modules/erp/store/BackDialog.vue'

export default {
  mixins: [SweetTable],
  components: {
    ImagePreviewer,
    ProductReceiveDialog,
    ProductRowCard,
    BackDetailDialog: () => {
      return import('@/views/modules/erp/purchase/BackDetailDialog.vue')
    },
    StoreLogEditDialog,
    BackDialog
  },
  data () {
    return {
      dateArr: [],
      dataForm: {
        hasReceipt: '',
        hasBack: '',
        fuzzyOrderCode: '',
        status: null,
        orderCode: '',
        batchCode: '',
        sellerName: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        sourceType: this.sourceType,
        sendDateBegin: '',
        sendDateEnd: '',
        queryType: this.queryType,
        isVirtual: null,
        senderName: '',
        type: 1
      },
    }
  },
  props: {
    hasPage: {
      type: Boolean,
      default: true
    },
    //是否显示查询条件
    showQueryBar: {
      type: Boolean,
      default: true
    },
    defaultQueryParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hideButtons: {
      type: Array,
      default: () => []
    },
    hideQuery: {
      type: Array,
      default: () => []
    },
    hideColumns: {
      type: Array,
      default: () => []
    },
    sourceType: {
      type: String,
      default: '',
    },
    queryType: {
      type: String,
      default: '',
    },
    otherHeight: {
      type: Number,
      default: 0,
    },
    tableHeight: {
      type: Number,
      default: null
    }
  },
  computed: {
    //兼容不同的sourceType和sourceTable取值
    sourceTable () {
      if (this.sourceType === 'make') {
        return 'ma_factory_make_detail'
      } else if (this.sourceType === 'purchase') {
        return 'ma_purchase'
      }
    },
    sendDateRange: {
      get: function () {
        return [this.dataForm.sendDateBegin, this.dataForm.sendDateEnd]
      },
      // setter
      set: function (newVal) {
        this.dataForm.sendDateBegin = newVal[0]
        this.dataForm.sendDateEnd = newVal[1]
      }
    }
  },
  watch: {
    tableHeight (newVal) {
      alert(newVal)
    },
    sourceType: {
      handler: function (newVal) {
        this.dataForm.sourceType = newVal
        this.reload()
      },
      immediate: true
    }
  },
  methods: {
    //返回勾选的行数据
    getSelectedRows () {
      if (!this.$refs.table) {
        return []
      }
      return this.$refs.table.dataListSelections
    },
    showBackDetailDialog (row) {
      this.$refs.BackDetailDialog.init(row.id)
    },
    cellStyleHandler ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'sendCount') {
        if (row.totalReceiveCount > row.planCount) {
          return {
            color: 'red'
          }
        }
      }
      if (column.property === 'senderName' || column.property === 'receiverName') {
        if (row.isVirtual === 0) {
          return {
            color: '#a400a2'
          }
        }
      }
      if (this.queryType === 'seller' && row.status === 10) {
        return {
          color: '#a400a2'
        }
      }
    },
    showStoreLogEditDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要修改的记录')
      }
      if (rows.length > 1) {
        return this.$message.warning('只能选择一条记录进行修改')
      }
      this.$refs.StoreLogEditDialog.init(rows[0])
    },
    //撤回发货单(批量删除)
    batchDel () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要撤回的记录')
      }
      let confirmMsg = `确定要撤回选中的记录么?`
      this.$confirm(confirmMsg, '提示').then(() => {
        this.$api2.post('/erp/store/log/del', { ids: rows.map(item => item.id) }).then(res => {
          this.$message.success('撤回成功')
          this.reload()
          this.clearSelection()
        })
      })
    },
    //显示退货弹窗
    showBackDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要调整单价的记录')
      }
      if (rows.length > 1) {
        return this.$message.warning('只能选择一条记录进行调整单价')
      }

      this.$refs.BackDialog.init(rows[0])
    },
    //显示调整单价弹窗
    // showChangePriceDialog () {
    //   let rows = this.$refs.table.dataListSelections
    //   if (this.$c.isArrayEmpty(rows)) {
    //     return this.$message.warning('请选择需要调整单价的记录')
    //   }
    //   if (rows.length > 1) {
    //     return this.$message.warning('只能选择一条记录进行调整单价')
    //   }
    //
    //   this.$refs.ChangePriceDialog.init(rows[0])
    // },
    //显示公司端确认收货弹窗
    showReceiveDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.warning('请选择需要确认收货的记录')
      }
      let receiveDataList = rows.map(row => {
        return {
          orderCode: row.orderCode,
          batchCode: row.batchCode,
          id: row.id,
          productId: row.productId,
          product: row.product,
          sendDate: row.operateTime,
          senderName: row.senderName,
          sendCount: row.sendCount,
          receiveCount: row.sendCount,
          planCount: row.planCount,
          totalReceiveCount: row.totalReceiveCount,
          sourceTable: this.sourceTable,
          receiveOptTime: moment().format('YYYY-MM-DD'),
        }
      })
      this.$refs.ProductReceiveDialog.init(receiveDataList)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.fullRemark = [row.remark, row.sendRemark, row.receiveRemark].join(' ')
        row.fullImgs = []
        if (row.imgs) {
          row.imgs = JSON.parse(row.imgs)
          row.fullImgs = row.fullImgs.concat(row.imgs)
        }
        if (row.sendImgs) {
          row.sendImgs = JSON.parse(row.sendImgs)
          row.fullImgs = row.fullImgs.concat(row.sendImgs)
        }
        if (row.receiveImgs) {
          row.receiveImgs = JSON.parse(row.receiveImgs)
          console.log('recevieImgs', row.receiveImgs)
          row.fullImgs = row.fullImgs.concat(row.receiveImgs)
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
